'use strict';

angular.module(ApplicationConfiguration.applicationModuleName).factory('DisapprovalReason', ['$resource', '$stateParams', 'apiSettings', function ($resource, $stateParams, apiSettings) {
	return $resource(apiSettings.baseUri + 'v1/disapprovalreasons/:id', { id: '@id' }, {
		'list': {
			method: 'GET',
			isArray: false,
			params: {
				page: 1,
				pageSize: apiSettings.defaultPageSize,
				keyword: ''
			}
		},
		'listIds': {
			url: apiSettings.baseUri + 'v1/disapprovalreasons/list/ids',
			method: 'GET',
			isArray: true
		},
		'insert': {
			method: 'POST'
		},
		'update': {
			method: 'PUT'
		},
		'delete': {
			method: 'DELETE'
		}
	});
}]);